import styled from 'styled-components'
import { colors } from '../../../lib/colors'
import { BUTTON_STYLED_PROPS } from './interface'

export const PositionsWrapper = styled.div<BUTTON_STYLED_PROPS>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 22px;
  padding-bottom: ${({ padding }) => padding || '0px'};
`

export const PositionsContainer = styled.div<BUTTON_STYLED_PROPS>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3px 3px 0 3px;
  cursor: pointer;
  pointer-events: none;
  span {
    font-size: 10px;
    color: ${({ active, withBet }) =>
      active || withBet ? colors.secondary : colors.quaternary};
    transition: color 500ms linear;
  }
`
export const Position = styled.div<BUTTON_STYLED_PROPS>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  margin-bottom: 6px;
  background: ${({ active, withBet }) =>
    active && !withBet
      ? colors.primaryDark
      : withBet
      ? colors.secondary
      : colors.primaryLight};
  border: ${({ active, withBet }) =>
    active || withBet ? `3px solid ${colors.secondary}` : ''};
`
export const Content = styled.div<BUTTON_STYLED_PROPS>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2.5px solid;
  border-color: ${({ active, withBet }) =>
    active || withBet ? colors.primaryDark : colors.primaryLight};
  color: ${({ active, withBet }) =>
    active && !withBet ? colors.secondary : colors.tertiary};
  font-size: 10px;
  transition: all 200ms linear;
  svg {
    stroke-width: ${({ turn }) => turn && 0};
  }
  path {
    fill: ${colors.tertiary};
    stroke: ${colors.tertiary};
  }
`
